import { ToastContainer } from "react-toastify";
import { defineBridgeElement, lazyBridgeElement } from "./bridge-element";
import { Footer } from "./footer/footer";
import { Header } from "./header/header";
import { MapNav } from "./map-nav/map-nav";
import { MarketingFooter } from "./marketing-footer/marketing-footer";
import { OfflineWarning } from "./offline-warning/offline-warning";
import { withSafeUrl } from "./url";
import { SidePanel } from "./side-panel/side-panel";

defineBridgeElement("alk-main-nav", Header);
defineBridgeElement("alkmaps-navigation", MapNav);
defineBridgeElement("map-footer", Footer);
defineBridgeElement("marketing-footer", MarketingFooter);
defineBridgeElement("offline-warning", OfflineWarning);
defineBridgeElement("toast-container", ToastContainer);
defineBridgeElement("side-panel", SidePanel);

lazyBridgeElement("hubspot-form", () => import("./hubspot-form"));
lazyBridgeElement("terms-of-service", () => import("./tos"));

declare global {
	interface Window {
		$exports: typeof $exports;
	}
}

const $exports = {
	withSafeUrl,
};

window.$exports = $exports;
